var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgNftPayment(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0D242",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.291 27.797a3.215 3.215 0 01-1.137 2.447 3.185 3.185 0 01-2.596.704l-3.864-.677a10.023 10.023 0 00-3.38 0l-3.873.677a4.185 4.185 0 01-.425.045h-.125a3.184 3.184 0 01-2.243-.941 3.21 3.21 0 01-.932-2.255 12.054 12.054 0 011.566-5.957 11.994 11.994 0 014.3-4.395 6.63 6.63 0 014.62-.81c.776.135 1.522.41 2.2.81a11.979 11.979 0 014.303 4.394 12.038 12.038 0 011.564 5.958h.022z",
    fill: "#FFD966"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.291 27.797a3.213 3.213 0 01-1.137 2.447 3.183 3.183 0 01-2.596.704l-3.864-.677a10.024 10.024 0 00-3.38 0l-3.873.677c-.14.023-.283.037-.425.045l7.187-14.358a6.53 6.53 0 012.2.81 11.977 11.977 0 014.302 4.394 12.04 12.04 0 011.564 5.958h.022z",
    fill: "#FAB14B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.465 15.538c1.527 0 2.765-1.463 2.765-3.269C19.23 10.464 17.992 9 16.465 9c-1.527 0-2.764 1.464-2.764 3.27 0 1.805 1.237 3.268 2.764 3.268zM26.3 12.27c0 1.803-1.24 3.26-2.765 3.26a2.4 2.4 0 01-1.511-.537 3.413 3.413 0 01-1.254-2.724C20.77 10.473 22.01 9 23.535 9c.46 0 .912.136 1.297.39a3.368 3.368 0 011.467 2.88z",
    fill: "#FFD966"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.535 15.53a2.4 2.4 0 01-1.511-.537l2.809-5.603a3.367 3.367 0 011.466 2.88c0 1.803-1.24 3.26-2.764 3.26z",
    fill: "#FAB14B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.957 16.805a2.505 2.505 0 00-.766-1.798 2.483 2.483 0 00-1.822-.691 2.585 2.585 0 00-1.708.854A2.605 2.605 0 009 16.967V18.1a6.09 6.09 0 001.35 3.822.433.433 0 00.689 0l2.493-3.682c.287-.422.436-.924.425-1.435z",
    fill: "#FFD966"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.035 16.805a2.504 2.504 0 01.77-1.8 2.485 2.485 0 011.826-.69 2.585 2.585 0 011.708.855c.44.492.677 1.135.661 1.796V18.1a6.082 6.082 0 01-1.342 3.822.44.44 0 01-.697 0l-2.486-3.682a2.458 2.458 0 01-.44-1.435z",
    fill: "#FAB14B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.158 22.334h-2.875v-2.886c0-.342-.135-.67-.376-.911a1.281 1.281 0 00-2.19.91v2.887h-2.875c-.34 0-.667.136-.908.377a1.291 1.291 0 00.908 2.2h2.875v2.886c0 .342.135.67.376.911a1.28 1.28 0 002.19-.91V24.91h2.875c.34 0 .667-.136.907-.377a1.291 1.291 0 00-.907-2.2z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 9)",
    d: "M0 0h22v22H0z"
  })))));
}
export default SvgNftPayment;